import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';

import THead from './THead';
import { IData } from '../../helpers/interface';
interface IProps {
  moduleData: IData;
  machineData: any;
  departmentData: any;
  isView: boolean;
  setRender: any;
}

const TController = ({
  moduleData,
  machineData,
  departmentData,
  isView,
  setRender
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
            machineData,
            departmentData,
            setRender,
          }}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
